import { Amplify } from 'aws-amplify';

// Configure Amplify with Identity Pool for AWS credentials
export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
        region: process.env.REACT_APP_AWS_REGION,
        loginWith: {
          oauth: {
            domain: 'us-east-1mqmgra6ec.auth.us-east-1.amazoncognito.com',
            scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [
              'http://localhost:3000/oauth/callback',
              'https://getcertifiable.com/oauth/callback',
              'https://www.certifiable.me/oauth/callback',
              'https://dev.d1d7vib6srssm3.amplifyapp.com/oauth/callback'
            ],
            redirectSignOut: [
              'http://localhost:3000/',
              'https://getcertifiable.com/',
              'https://www.certifiable.me/',
              'https://dev.d1d7vib6srssm3.amplifyapp.com/'
            ],
            responseType: 'code'
          },
          username: true,
          email: true
        }
      }
    }
  });
};

// AWS SDK Configuration
export const awsConfig = {
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  credentials: null, // Will be set by Cognito Identity Pool
};

// DynamoDB Table Names
export const TABLES = {
  USERS: process.env.REACT_APP_DYNAMODB_USERS_TABLE || 'asl-ceu-tracker-users',
  CEUS: process.env.REACT_APP_DYNAMODB_CEUS_TABLE || 'asl-ceu-tracker-ceus',
};

// S3 Bucket Names
export const BUCKETS = {
  PROFILE_PHOTOS: process.env.REACT_APP_S3_PROFILE_PHOTOS_BUCKET || 'asl-ceu-tracker-profile-photos',
};

// API Gateway
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export default {
  configureAmplify,
  awsConfig,
  TABLES,
  BUCKETS,
  API_BASE_URL,
};
